import ContactForm from "@/components/contact/ContactForm";

const Contact = () => {
  return (
    <>
      <section className="py-16 md:py-24">
        <div className="container">
          <h1 className="sr-only">Neem contact op met Rinqel</h1>
          <ContactForm />
        </div>
      </section>

      <section className="pb-16 md:pb-24">
        <div className="container">
          <div className="mx-auto max-w-3xl space-y-6 text-muted-foreground">
            <div className="space-y-3">
              <h2 className="text-2xl font-bold text-foreground">Wanneer bereik je ons?</h2>
              <p>
                Tijdens kantooruren (ma–vr 09:00–18:00) krijg je direct een techneut aan de lijn.
                Geen keuzemenu, geen wachtrij, geen ticketnummer. Bel of WhatsApp ons en je hebt
                meestal binnen een paar minuten antwoord. Mail kan natuurlijk ook — daar reageren
                we doorgaans binnen één werkdag op.
              </p>
              <p>
                Heb je een contract bij ons en gaat er buiten kantooruren iets mis? Dan zijn we
                24/7 bereikbaar voor storingen. Geen voicemail die niemand afluistert, maar gewoon
                iemand die meteen oppakt en aan de slag gaat.
              </p>
            </div>

            <div className="space-y-3">
              <h2 className="text-2xl font-bold text-foreground">In welke regio's werken we?</h2>
              <p>
                Rinqel zit in Limmen, vlak bij Alkmaar, en werkt voor klanten door heel Nederland.
                Het meeste regelen we op afstand — beheer, monitoring, support en migraties doen
                we vanaf onze plek, zonder dat jij er last van hebt. Komt er een keer iets fysiek
                op locatie kijken (een nieuwe centrale, een wifi-meting, hardware-uitrol)? Dan
                stappen we in de auto. In Noord-Holland zijn we daar het snelst, maar voor de
                rest van het land plannen we het gewoon in.
              </p>
              <p>
                Of je nu een ZZP'er bent met één laptop of een organisatie met honderd werkplekken:
                je krijgt dezelfde mensen aan de lijn, hetzelfde vaste maandbedrag en dezelfde
                aanpak. Maandelijks opzegbaar, geen uurtje-factuurtje, geen kleine lettertjes.
              </p>
            </div>

            <div className="space-y-3">
              <h2 className="text-2xl font-bold text-foreground">Wat kun je verwachten na je bericht?</h2>
              <p>
                We bellen of mailen je terug, stellen een paar concrete vragen om je situatie te
                begrijpen, en geven je een eerlijk advies — ook als dat betekent dat overstappen
                voor jou (nog) niet nodig is. Daarna krijg je een transparante prijsindicatie en
                een helder migratieplan. Pas als jij ja zegt gaan we aan de slag. Vrijblijvend dus,
                en zonder commerciële druk.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
